import styled from "styled-components";

export const TitleLabelText = styled.span`
  font-weight: bold;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px;
`;

export const HeaderLabelText = styled.span`
  font-weight: bold;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px;
  width: 200px;
  display: inline-block;
`;

export const LabelText = styled.span`
  font-size: 10px;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextInDot = styled.span`
  height: 20px;
  width: 20px;
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
  background-color: #FFFF00;
  border-radius: 50%;
  display: inline-block;
`;
